"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.CacheService = void 0;
var CacheService = /** @class */ (function () {
    function CacheService() {
    }
    CacheService.get = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.exists(key))
                    return [2 /*return*/, this.objCache[key].value];
                return [2 /*return*/];
            });
        });
    };
    CacheService.exists = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.objCache[key]) {
                    if (Date.now() < this.objCache[key].expiresAt)
                        return [2 /*return*/, true];
                }
                return [2 /*return*/, false];
            });
        });
    };
    CacheService.set = function (key, value, option) {
        return __awaiter(this, void 0, void 0, function () {
            var expiresAt;
            return __generator(this, function (_a) {
                expiresAt = this.defaultExpiresAt;
                if (option === null || option === void 0 ? void 0 : option.expiresInMinutes) {
                    expiresAt = Date.now() + 1000 * option.expiresInMinutes;
                }
                this.objCache[key] = {
                    expiresAt: expiresAt,
                    value: value
                };
                return [2 /*return*/, true];
            });
        });
    };
    CacheService["delete"] = function (keys) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, keys_1, key;
            return __generator(this, function (_a) {
                for (_i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                    key = keys_1[_i];
                    delete this.objCache[key];
                }
                return [2 /*return*/];
            });
        });
    };
    CacheService.withCache = function (callback, key, option) {
        return __awaiter(this, void 0, void 0, function () {
            var result, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, this.exists(key)];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.get(key)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [4 /*yield*/, callback()];
                    case 4:
                        result = _a.sent();
                        this.set(key, result, option);
                        return [2 /*return*/, this.get(key)];
                    case 5:
                        ex_1 = _a.sent();
                        throw ex_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CacheService.objCache = {};
    CacheService.defaultExpiresAt = new Date(2099, 1, 1).getTime();
    return CacheService;
}());
exports.CacheService = CacheService;
CacheService;
//# sourceMappingURL=CacheService.js.map